import { render, staticRenderFns } from "./complaintsRegistration.vue?vue&type=template&id=842975d8&scoped=true"
import script from "./complaintsRegistration.vue?vue&type=script&lang=js"
export * from "./complaintsRegistration.vue?vue&type=script&lang=js"
import style0 from "./complaintsRegistration.vue?vue&type=style&index=0&id=842975d8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842975d8",
  null
  
)

export default component.exports